import { icons } from 'src/assets/iconDef/icon.def';

/**
 * KX Insights side-menu: manage dashboards (landing), author one (designer),
 * and a quick link to the demo.
 */
export const kxinsightsMenuDef = [
  {
    name: 'menu.kxinsights',
    icon: icons.application.role,
    data: { nav_url: 'kxinsights_m' },
    children: [
      {
        name: 'menu.kxinsights_dashboards',
        resource: 'bi_dashboard',
        icon: icons.list.horizontalList,
        url: 'bi_dashboard',
        check_permission: false,
        breadcrumb: 'Dashboards',
      },
      {
        name: 'menu.kxinsights_scheduling',
        resource: 'bi_query',
        icon: icons.list.horizontalList,
        url: 'scheduling',
        check_permission: false,
        breadcrumb: 'Alerts & Subscriptions',
      },
      {
        // Built-in dashboard (src/modules/kxinsights/usage-dashboard.ts) over the
        // BI Usage dataset; the engine scopes it to the viewer's own account.
        name: 'menu.kxinsights_usage',
        resource: 'bi_query',
        icon: icons.list.horizontalList,
        url: 'bi-usage',
        check_permission: false,
        breadcrumb: 'BI Usage',
      },
      {
        name: 'menu.kxinsights_designer',
        resource: 'bi_dashboard',
        icon: icons.list.horizontalList,
        url: 'designer',
        check_permission: false,
        breadcrumb: 'Designer',
      },
    ],
  },
];
